import { render, staticRenderFns } from "./AxCommunication.vue?vue&type=template&id=137e0d33&scoped=true&"
import script from "./AxCommunication.vue?vue&type=script&lang=js&"
export * from "./AxCommunication.vue?vue&type=script&lang=js&"
import style0 from "./AxCommunication.vue?vue&type=style&index=0&id=137e0d33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e0d33",
  null
  
)

export default component.exports